import { useCallback } from "react";

import { createDefaultMutationHook } from "hooks/useMutationHandler";
import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";

import { CREATE_INTENT_PROJECT } from "./gql";

type CreateIntentProjectInput = {
  name: string;
  description?: string;
  space: string;
  labels?: string[];
  workerPool?: string;
  runnerImage?: string;
};

const createIntentProjectHook = createDefaultMutationHook(CREATE_INTENT_PROJECT);

const useCreateIntentProject = () => {
  const { reportSuccess } = useTypedContext(FlashContext);

  const [createMutation, { loading, error }] = createIntentProjectHook();

  const createIntentProject = useCallback(
    (input: CreateIntentProjectInput, callback?: (id: string) => void) => {
      createMutation(
        {
          name: input.name,
          description: input.description || null,
          space: input.space,
          labels: input.labels ?? null,
          workerPool: input.workerPool ?? null,
          runnerImage: input.runnerImage ?? null,
        },
        (data) => {
          const id = data?.intentProjectCreate.id;
          if (id) {
            reportSuccess({ message: "Intent Project created successfully" });
            callback?.(id);
          }
        }
      );
    },
    [createMutation, reportSuccess]
  );

  return {
    createIntentProject,
    loading,
    error,
  };
};

export default useCreateIntentProject;
